// removed by extract-text-webpack-plugin
module.exports = {"textStyle":"buttonMenu__textStyle--2hJMB","labelText":"buttonMenu__labelText--16yFt","filterMenu":"buttonMenu__filterMenu--1e6C_","fixedWidthMenu":"buttonMenu__fixedWidthMenu--U9g_j"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/FilterComponents/buttonMenu.css
// module id = 3R7p
// module chunks = 47